import { useEffect } from 'react';
import { useState } from 'react';
import {
    Avatar,
    Chip,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    InputLabel,
    Radio,
    RadioGroup,
    Typography
} from '@material-ui/core';

import { SecondaryButton, SelectBox, TextBox } from '../../../../../../Core/FormInput';

import { postJobProgressAWaitingPart } from '../../../../../../Core/Service/communicator-service';
import { useContext } from 'react';
import AppContext from '../../../../../../App/AppContext';

import { singleEmailValidation } from '../../../../../../Core/Service/StaticService';

const AwaitingPartModal = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        messaegList: [],
        actionLog: false,
        editActionLog: false,
        selectedStatus: props.selectedStatus,
        logText: '',
        errors: {}
    });

    useEffect(async () => {
        setState((st) => ({ ...st, logText: props.smsText, isCustomerUpdate: props.sendSMSUpdate, isUpdateSms: props.sendSMSUpdate }));
    }, [props]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type == 'checkbox') {
            setState((st) => {
                let newSt = { ...st };
                newSt[name] = checked;
                if (!newSt.isCustomerUpdate) {
                    newSt.isCustomerEmail = '';
                }
                if (!newSt.isUpdateSms) {
                    newSt.isPhoneNo = '';
                }
                return newSt;
            });
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const validation = () => {
        let { partStatus, partETA, isCustomerUpdate, isCustomerEmail, isUpdateSms, isPhoneNo } = state;
        let isValid = true;
        let errors = {};

        if (!partStatus) {
            isValid = false;
            errors.partStatus = 'Please Select Part Status';
        }
        if (!partETA) {
            isValid = false;
            errors.partETA = 'Please Select Part Status';
        }
        if (isCustomerUpdate && !singleEmailValidation(isCustomerEmail)) {
            isValid = false;
            errors.isCustomerEmail = 'Please Add Customer Email';
        }
        if (isUpdateSms && !isPhoneNo) {
            isValid = false;
            errors.isPhoneNo = 'Please Add Customer Email';
        }

        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validation()) {
            let data = {
                headerRecordID: props.headerRecordID,
                partETA: state.partETA,
                partStatus: state.partStatus,
                status: +state.selectedStatus,
                logText: state.logText,
                isPhoneNo: state.isPhoneNo,
                isCustomerEmail: state.isCustomerEmail
            };
            let res = await postJobProgressAWaitingPart(data);
            if (res.success) {
                showToast(`Awaiting Part Added Successfully`);
                props.onClose(true);
            } else {
                showToast(`Awaiting Part Failed To Add`);
            }
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <InputLabel shrink style={{ paddingBottom: 10 }}>
                    Part Status
                </InputLabel>
                <SelectBox List={props.partStatusList} name="partStatus" value={+state.partStatus} onChange={handleInput} />
                <FormHelperText error>{state.errors.partStatus}</FormHelperText>
            </Grid>
            <Grid item xs={6}>
                <InputLabel shrink>Part ETA</InputLabel>
                <TextBox type="datetime-local" name="partETA" value={state.partETA} variant="outlined" fullWidth onChange={handleInput} />
                <FormHelperText error>{state.errors.partETA}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <Typography color="secondary">Customer Message</Typography>
                <TextBox placeholder="Message" type="text" name="logText" variant="outlined" fullWidth value={state.logText} onChange={handleInput} />
                <FormHelperText error>{state.errors.logText}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink>
                    <input type="checkbox" style={{ cursor: 'pointer' }} name="isCustomerUpdate" onChange={handleInput} checked={state.isCustomerUpdate} />
                    Customer Email
                </InputLabel>
                <TextBox
                    placeholder="Email update to customer"
                    type="email"
                    name="isCustomerEmail"
                    variant="outlined"
                    fullWidth
                    value={state.isCustomerEmail}
                    onChange={handleInput}
                    error={state.isCustomerUpdate}
                />
                <FormHelperText error>{state.errors.isCustomerEmail}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink>
                    <input type="checkbox" style={{ cursor: 'pointer' }} onChange={handleInput} name="isUpdateSms" checked={state.isUpdateSms} />
                    Phone Number
                </InputLabel>
                <TextBox
                    placeholder="Phone Number"
                    type="tel"
                    name="isPhoneNo"
                    variant="outlined"
                    fullWidth
                    value={state.isPhoneNo}
                    onChange={handleInput}
                    error={state.isUpdateSms}
                />
                <FormHelperText error>{state.errors.isPhoneNo}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                    Awaiting Part
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AwaitingPartModal;
